import React, { useState, useEffect, useContext } from "react";
import { LoadersContext } from "_models/context/app";

export const ActionUnbarringHook = (props) => {
    const { actionPostUnbarringAction, ticketId, imeiNumber } = props || {};
    const [modalOpen, setModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [alert, setAlert] = useState(false);
    const [errorMssge, setErrorMssge] = useState("");
    const [severityAlert, setSeverityAlert] = useState("info");

    const loadersContext = useContext(LoadersContext);
    const { isScreenLoading, setIsScreenLoading } = loadersContext || {};

    useEffect(() => {
        setIsScreenLoading(isLoading);
    }, [isLoading]);

    const handleClickUnbarring = () => {
        setModalOpen(true);
    };
    useEffect(() => {
        const { postUpdateUnbarringObj } = actionPostUnbarringAction || {};

        if (actionPostUnbarringAction.postUpdateUnbarringObj.length != 0) {
            if (actionPostUnbarringAction.loading == false) {
                setErrorMssge(postUpdateUnbarringObj.message);
                setSeverityAlert("error");
                setAlert(true);
                setIsLoading(false);
            } else {
                setSeverityAlert("success");
                setErrorMssge("Unbarring satisfactorio");
                setAlert(true);
                setIsLoading(false);
            }
        }
    }, [actionPostUnbarringAction]);

    const handleSubmit = () => {
        setIsLoading(true);
        props.postUnbarringAction(ticketId);
    };
    const clearFunction = () => {
        setAlert(false);
    };

    return {
        modalOpen,
        setModalOpen,
        isLoading,
        setIsLoading,
        alert,
        setAlert,
        errorMssge,
        setErrorMssge,
        severityAlert,
        setSeverityAlert,
        handleClickUnbarring,
        handleSubmit,
        clearFunction,
    };
};
